<template>
    <div>
    </div>
</template>

<script>
export default {
  name: 'onboardUser',
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/views/OnboardUser.vue